import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import moment from 'moment';

import PageHeader from '../../../components/common/PageHeader';
import { useIsLoggedInQuery } from '../../../redux/apis/authApi';
import { ADMIN_HR_ROLES } from '../../../utils/constant/global';

import ViolationTable from './components/ViolationTable';
import ApplyLeaveModal from './components/ApplyLeaveModal';

import './AttendanceViolation.scss';

const now = moment();

const initialState = {
  periodType: 'month',
  date: now.format('YYYY-MM-DD'),
  startDate: now.clone().startOf('month').format('YYYY-MM-DD'),
  endDate: now.format('YYYY-MM-DD'),
  month: now.month() + 1,
  year: now.year(),
  violationType: 'all',
  search: '',
  currentPage: 1,
  rowsPerPage: 20,
  isNext: false
};

const AttendanceViolationList = () => {
  const { data: isLogin } = useIsLoggedInQuery();
  const [state, setState] = useState(initialState);
  const [selectedViolation, setSelectedViolation] = useState(null);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const roleName = isLogin?.data?.hrxRole?.roleName;
  const canView = ADMIN_HR_ROLES.includes(roleName);

  if (isLogin && !canView) {
    return <Navigate to="/permission-denied" replace />;
  }

  const handleApplyLeave = (row) => {
    setSelectedViolation(row);
    setShowApplyModal(true);
  };

  const handleLeaveApplied = () => {
    setRefreshKey((k) => k + 1);
  };

  return (
    <div className="container-xxl att-violation-page">
      <PageHeader headerTitle="Attendance Violations" />
      <div className="card border-0 shadow-sm att-violation-card">
        <div className="card-body">
          <ViolationTable
            key={refreshKey}
            state={state}
            setState={setState}
            onApplyLeave={handleApplyLeave}
            onActionSuccess={handleLeaveApplied}
          />
        </div>
      </div>

      <ApplyLeaveModal
        show={showApplyModal}
        violation={selectedViolation}
        onClose={() => {
          setShowApplyModal(false);
          setSelectedViolation(null);
        }}
        onSuccess={handleLeaveApplied}
      />
    </div>
  );
};

export default AttendanceViolationList;
